import React from "react";
import { Skeleton } from "components";
import { Col, Row } from "react-bootstrap";

export default function HorizontalCardSkeleton() {
  return (
    <div className="bg-white rounded mb-2 py-4 px-4">
      <Row className="">
        <Col xl={4} lg={5} md={9} sm={9} xs={9}>
          <Row className="">
            <Col xl={3} lg={3} md={4} sm={3} xs={3}>
              <Skeleton count={1} height={60} width={"100%"} />
            </Col>
            <Col xl={9} lg={9} md={8} sm={9} xs={9}>
              <Skeleton count={1} height={10} width={"80%"} />
              <Skeleton count={1} height={10} width={"100%"} />
            </Col>
          </Row>
        </Col>
        <Col xl={7} lg={5} md={0} sm={0} xs={0} className="d-none d-lg-block">
          <Skeleton count={1} height={10} width={"50%"} />
        </Col>
        <Col xl={1} lg={2} md={3} sm={3} xs={3}>
          <Row className="align-items-center">
            <Col
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={6}
              className="p-0 m-0 text-center"
            >
              <Skeleton count={1} height={30} width={"100%"} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
